<div id="dashboard" class="pb-8">
  <div class="flex flex-col gap-8">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      @for (card of cards; track card.id) {
        <app-metric-card
          class="col-span-1"
          [text]="card.text"
          [data]="card.data"
          [iconPrime]="card.iconPrime"
          [clickable]="card.clickable || false"
          (click)="onMetricCardClicked(card.onClick)"
          *data-permissions="card.auth || null" />
      }
    </div>

    <div class="card mb-0">
      <app-dashboard-calendar
        [events]="events$ | async"
        [loading]="state.loading()"
        (rangeChanged)="onCalendarRangeChanged($event)"
        (eventClicked)="onEventClicked($event)" />
    </div>
  </div>
</div>
